import { TenantApp } from 'application/Shared/types/tenantApp';
import { t } from 'i18next';

/**
 * Transformer function to get the data for the applications classification chart.`
 * @returns The data for the applications classification chart.
 */
export function applicationsClassification({ data }: { data: TenantApp[] }) {
    const { classified, unclassified } = data.reduce(
        (
            acc: { classified: number; unclassified: number },
            curr: TenantApp
        ) => {
            if (curr.classified) {
                acc.classified += 1;
            } else {
                acc.unclassified += 1;
            }
            return acc;
        },
        { classified: 0, unclassified: 0 }
    );

    return {
        series: [
            { name: t('Common.classified'), value: classified },
            { name: t('Common.unclassified'), value: unclassified }
        ]
    };
}
